import KeyboardNavigation from '../../grid/keyboardNavigation';

export default instance => {
  instance.attachEvent('onBeforeTaskDrag', (id, mode, event) => !KeyboardNavigation.creatingTask);
};
